import React, { memo, PropsWithChildren } from 'react';
import { HEADER_HEIGHT } from 'shared/constants';
import styled from 'styled-components';

import PageTopPanel from './PageTopPanel';

type WithPageTopPanelProps = PropsWithChildren<{
    className?: string;
    text?: string;
    onBackClick?: () => void;
    loading?: boolean;
    disabled?: boolean;
    actions?: React.ReactNode[];
}>;

function WithPageTopPanel(props: WithPageTopPanelProps) {
    const {
        className,
        children,
        disabled,
        text,
        onBackClick,
        loading,
        actions
    } = props;

    return (
        <Root className={ className }>
            <StyledPageTopPanel text={ text }
                onBackClick={ onBackClick }
                loading={ loading }
                disabled={ disabled }
                actions={ actions }
            />
            { children }
        </Root>
    );
}

export default memo(WithPageTopPanel);

const Root = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    flex-shrink: 0;
`;

const StyledPageTopPanel = styled(PageTopPanel)`
    position: sticky;
    top: ${ HEADER_HEIGHT }px;
    z-index: 20;
`;
